import { symbol as symbol$1, equals } from '../Equal/dist/effect-Equal.esm.js';
import { pipe } from '../Function/dist/effect-Function.esm.js';
import { symbol, combine, hash } from '../Hash/dist/effect-Hash.esm.js';

const FiberStatusSymbolKey = "effect/FiberStatus";

/** @internal */
const FiberStatusTypeId = /*#__PURE__*/Symbol.for(FiberStatusSymbolKey);

/** @internal */
const OP_DONE = "Done";

/** @internal */

/** @internal */
const OP_RUNNING = "Running";

/** @internal */

/** @internal */
const OP_SUSPENDED = "Suspended";

/** @internal */

/** @internal */
class Done {
  [FiberStatusTypeId] = FiberStatusTypeId;
  _tag = OP_DONE;
  [symbol]() {
    return pipe(hash(FiberStatusSymbolKey), combine(hash(this._tag)));
  }
  [symbol$1](that) {
    return isFiberStatus(that) && that._tag === OP_DONE;
  }
}

/** @internal */
class Running {
  [FiberStatusTypeId] = FiberStatusTypeId;
  _tag = OP_RUNNING;
  constructor(runtimeFlags) {
    this.runtimeFlags = runtimeFlags;
  }
  [symbol]() {
    return pipe(hash(FiberStatusSymbolKey), combine(hash(this._tag)), combine(hash(this.runtimeFlags)));
  }
  [symbol$1](that) {
    return isFiberStatus(that) && that._tag === OP_RUNNING && this.runtimeFlags === that.runtimeFlags;
  }
}

/** @internal */
class Suspended {
  [FiberStatusTypeId] = FiberStatusTypeId;
  _tag = OP_SUSPENDED;
  constructor(runtimeFlags, blockingOn) {
    this.runtimeFlags = runtimeFlags;
    this.blockingOn = blockingOn;
  }
  [symbol]() {
    return pipe(hash(FiberStatusSymbolKey), combine(hash(this._tag)), combine(hash(this.runtimeFlags)), combine(hash(this.blockingOn)));
  }
  [symbol$1](that) {
    return isFiberStatus(that) && that._tag === OP_SUSPENDED && this.runtimeFlags === that.runtimeFlags && equals(this.blockingOn, that.blockingOn);
  }
}

/** @internal */
const done = /*#__PURE__*/new Done();

/** @internal */
const running = runtimeFlags => new Running(runtimeFlags);

/** @internal */
const suspended = (runtimeFlags, blockingOn) => new Suspended(runtimeFlags, blockingOn);

/** @internal */
const isFiberStatus = u => typeof u === "object" && u != null && FiberStatusTypeId in u;

/** @internal */
const isDone = self => self._tag === OP_DONE;

/** @internal */
const isRunning = self => self._tag === OP_RUNNING;

/** @internal */
const isSuspended = self => self._tag === OP_SUSPENDED;

export { FiberStatusTypeId, OP_DONE, OP_RUNNING, OP_SUSPENDED, done, isDone, isFiberStatus, isRunning, isSuspended, running, suspended };
